import React from "react";
import { OfferStatusInfo } from "../../../../widgets/OfferStatusInfo";
import Success from "../../../../shared/assets/icons/success.svg";
import styles from "./index.module.scss";
import { Loader } from "../../../../shared/ui/Loader";
import { useAppSelector } from "../../../../shared/store";
import { HintChip } from "../../../../shared/ui/HintChip";

export const SuccessOfferDetail = () => {
  const offerData = useAppSelector((state) => state.payment.offer);

  return (
    <OfferStatusInfo
      iconSrc={Success}
      title="Успешная оплата"
      subTitle={
        <div className={styles.container}>
          <h4 className={styles.subtitle}>{`Номер заказа ${
            offerData && offerData.humanId
          } `}</h4>
          {!offerData && <Loader />}
        </div>
      }
      description="Ваша оплата принята! В скором времени средства поступят на счет"
      content={
        <HintChip dotColor="#31b88a" className={styles.hintWrapper}>Платеж успешно принят</HintChip>
      }
      buttonVariant="primary"
      isBtnVisible={!!offerData?.goodLink}
      link={offerData?.goodLink}
    />
  );
};
